export const migraTipoDePaso = ["Código", "Nombre"];

export const migraPaso = ["Nombre", "Código", "Lugar", "Tipo de paso", "Estado"];

export const migraUsuarioPaso = [
    { field: "migraUsuarioPasoSemaforo", headerName: "Semáforo", width: 85, align: "center", headerAlign: "center" },
    { field: "apellidoYNombre", headerName: "Apellido y Nombre", flex: 1.5, minWidth: 150 },
    { field: "usuarioNroDeDocumentoX", headerName: "Documento", width: 100 },
    { field: "migraPasoNombre", headerName: "Paso", flex: 1, minWidth: 150 },
    { field: "migraUsuarioPasoTipo", headerName: "Tipo", width: 50, align: "center", headerAlign: "center" },
    { field: "migraUsuarioPasoFechaCreacion", headerName: "Fecha creación", width: 160, format: "dateTime" },
    { field: "migraUsuarioPasoFechaCheckin", headerName: "Fecha check-in", width: 160, format: "dateTime" },
    { field: "migraUsuarioPasoEstado", headerName: "Estado", width: 100 },
    { field: "migraUsuarioPasoIdentificacion", headerName: "Identificación", minWidth: 130 },
    { field: "migraUsuarioPasoOrigenDestino", headerName: "Origen/Destino", minWidth: 130 },
];

export const migraVuelo = [
    { field: "migraVueloEstado", headerName: "Estado", width: 100 },
    { field: "migraPasoNombre", headerName: "Paso", flex: 1, minWidth: 150 },
    { field: "migraVueloTipo", headerName: "Tipo", width: 90, align: "center", headerAlign: "center" },
    { field: "migraVueloFecha", headerName: "Fecha", width: 160, format: "dateTime" },
    { field: "migraVueloIdentificacion", headerName: "Identificación", width: 130 },
    { field: "migraVueloOrigenDestino", headerName: "Origen/Destino", width: 130 },
    { field: "totalPasajeros", headerName: "Pasajeros", width: 110, align: "center", headerAlign: "center" },
];

export const monitorMiaKey = [
    { field: "Estado", headerName: "Estado", flex: 1, align: 'center', headerAlign: 'center', maxWidth: 80, minWidth: 80 },
    { field: "NombreCompleto", headerName: "Apellido y Nombre", flex: 2, minWidth: 210 },
    { field: "DocumentoTipo", headerName: "Tipo de Doc.", flex: 1, minWidth: 100, maxWidth: 100 },
    { field: "DocumentoNumero", headerName: "Número de Doc.", flex: 2, minWidth: 130, maxWidth: 130, align: "right", headerAlign: "right" },
    { field: "Acceso", headerName: "Acceso", flex: 2, minWidth: 120 },
    { field: "Horarios", headerName: "Horarios", flex: 3, maxWidth: 320, minWidth: 320 },
    { field: "Eventos", headerName: "Eventos", flex: 3.5, minWidth: 270, maxWidth: 270 },
]

export const sucursales = [
    { field: "Código", headerName: "Código", flex: 1, minWidth: 150, maxWidth: 150 },
    { field: "Global", headerName: "Global", flex: 1, maxWidth: 100 },
    { field: "Nombre", headerName: "Nombre", flex: 1 },
];

export const baseHoteles = [
    { field: "Nombre", headerName: "Nombre", flex: 1, sortable: false },
    { field: "CUIT", headerName: "CUIT", flex: 1, align: "right", headerAlign: "right" }, // Al ser objeto, ignora la regla del NaN
    { field: "Provincia", headerName: "Provincia", flex: 1 },
    { field: "Localidad", headerName: "Localidad", flex: 1 },
    { field: "Estado", headerName: "Estado", flex: 1 },
    { field: "Telefono", headerName: "Teléfono", flex: 1, type: "string" }, // Al ser objeto, ignora la regla del NaN
    { field: "Email", headerName: "Email", flex: 1 },
    { field: "Check-in", headerName: "Check-in", flex: 1, align: "right", headerAlign: "right" },
    { field: "Check-out", headerName: "Check-out", flex: 1, align: "right", headerAlign: "right" },
];

export const hoteles = baseHoteles.map(col => ({
    ...col,
    sortable: col.field === 'numero' // Solo 'numero' será ordenable
}));

export const vouchersBase = [
    { field: "Apellido", headerName: "Apellido", flex: 1 },
    { field: "Nombre", headerName: "Nombre", flex: 1 },
    { field: "Tipo de Documento", headerName: "Tipo de Doc.", flex: 1 },
    { field: "Número de Documento", headerName: "Número de Doc.", flex: 1, align: "right", headerAlign: "right" },
    { field: "Fecha", headerName: "Fecha de asignación", flex: 1, align: "right", headerAlign: "right" },
    { field: "Fecha desde", headerName: "Fecha desde", flex: 1, align: "right", headerAlign: "right" },
    { field: "Fecha hasta", headerName: "Fecha hasta", flex: 1, align: "right", headerAlign: "right" },
    { field: "Asignados", headerName: "Asignados", flex: 1, align: "right", headerAlign: "right" },
    { field: "Disponibles", headerName: "Disponibles", flex: 1, align: "right", headerAlign: "right" },
    { field: "Usados", headerName: "Consumidos", flex: 1, align: "right", headerAlign: "right" },
    { field: "NumeroDesde", headerName: "Número desde", flex: 1, align: "right", headerAlign: "right" },
    { field: "NumeroHasta", headerName: "Número hasta", flex: 1, align: "right", headerAlign: "right" },
];

export const loteVouchers = vouchersBase.map(col => ({
    ...col,
    sortable: col.field === 'numero' // Solo 'numero' será ordenable
}));

export const vouchersDetails = [
    { field: "Nro de Voucher", headerName: "Nro de Voucher", flex: 1, align: "right", headerAlign: "right", sortable: false },
    { field: "Estado de Voucher", headerName: "Estado del voucher", flex: 1, align: "left", headerAlign: "left", sortable: false, maxWidth: 150 },
    { field: "Fecha de canje", headerName: "Utilizado", flex: 1, align: "right", headerAlign: "right", sortable: false, maxWidth: 120 },
    { field: "Nombre del Hotel", headerName: "Nombre del Hotel", flex: 1, align: "left", headerAlign: "left", sortable: false, minWidth: 250 },
    // { field: "Piso", headerName: "Piso", width: 90, align: "right", headerAlign: "right", sortable: false },
    // { field: "Habitación", headerName: "Habitación", flex: 1, align: "right", headerAlign: "right", sortable: false },
    { field: "Noche de uso", headerName: "Reserva", flex: 1, align: "right", headerAlign: "right", sortable: false },
    {
        field: "Estado",
        headerName: "Estado de la reserva",
        flex: 1,
        sortable: false,
        renderCell: (params) => (
            <span style={{
                fontSize: "1",
                color: params.value.startsWith("-") ? "#999" : "inherit",
                padding: params.value.startsWith("-") ? "4px 4px" : "0",
                fontStyle: params.value.startsWith("-") ? "italic" : "inherit"
            }}>
                {params.value}
            </span>
        )
    },
    {
        field: "Fecha estado",
        headerName: "Fecha estado",
        flex: 1, align: "right", headerAlign: "right",
        sortable: false,
        renderCell: (params) => (
            <span style={{
                fontSize: "1",
                color: params.value.includes("-") ? "#999" : "inherit",
                padding: params.value.includes("-") ? "4px 2px" : "0",
                fontStyle: params.value.includes("-") ? "italic" : "inherit",
                marginRight: params.value.includes("-") ? "2px" : "0"
            }}>
                {params.value}
            </span>
        )
    },
]

export const hotelAdmins = [
    { field: "Nombre", headerName: "Nombre", flex: 1, minWidth: 120 },
    { field: "Apellido", headerName: "Apellido", flex: 1, minWidth: 120 },
    { field: "Tipo de Documento", headerName: "Tipo de Doc.", width: 130, },
    { field: "Número de documento", headerName: "Número de Doc.", width: 150, align: "right", headerAlign: "right" },
    { field: "Sexo", headerName: "Sexo", width: 80 },
    { field: "Fecha de Nacimiento", headerName: "Fecha de Nacimiento", width: 180, align: "right", headerAlign: "right" },
    { field: "Rol", headerName: "Rol", width: 180, align: "right", headerAlign: "right" }
];

export const accesos = [
    { field: "COD", headerName: "Código", flex: 1, maxWidth: 125, minWidth: 125 },
    { field: "Nombre", headerName: "Nombre", flex: 3, minWidth: 100 },
    { field: "Zona", headerName: "Zona", flex: 2, minWidth: 100 },
    { field: "Global", headerName: "Global", flex: 1, maxWidth: 80, minWidth: 80 },
    { field: "Provincia", headerName: "Provincia", flex: 1, maxWidth: 140, minWidth: 140 },
    { field: "Localidad", headerName: "Localidad", flex: 1, maxWidth: 140, minWidth: 140 },
    { field: "Calle", headerName: "Calle", flex: 1, maxWidth: 100, minWidth: 100 },
    { field: "Número", headerName: "Número", flex: 1, maxWidth: 80, minWidth: 80 },
    { field: "Piso", headerName: "Piso", flex: 1, maxWidth: 80, minWidth: 80 },
    { field: "Unidad", headerName: "Unidad", flex: 1, maxWidth: 80, minWidth: 80 },
    { field: "Radio", headerName: "Radio", flex: 1, maxWidth: 80, minWidth: 80 },
];

export const documentType = ["Nombre", "Código", "Descripción", "Prioridad Firma", "PlaceHolder Firmantes", "PlaceHolder Tickets", "Mail", "Agrupa", "Cantidad"];

const stringSortComparator = (a, b) =>
    String(a ?? "").localeCompare(String(b ?? ""), "es", { sensitivity: "base" });

export const horarios = [
    { field: "Código", headerName: "Código", flex: 1, sortComparator: stringSortComparator, maxWidth: 140, minWidth: 140 },
    { field: "Nombre", headerName: "Nombre", flex: 1, sortComparator: stringSortComparator },
    { field: "Descripción", headerName: "Descripción", flex: 1, sortComparator: stringSortComparator },
    { field: "RangoHorarios", headerName: "Rango Horarios", flex: 1, minWidth: 320, sortable: false },
];
export const rangos = ["Entrada", "Salida", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

export const kioscos = [
    { field: "Acceso", headerName: "Acceso", flex: 4, minWidth: 120 },
    { field: "Zona", headerName: "Zona", flex: 3, minWidth: 120 },
    { field: "Identificación", headerName: "Identificación", flex: 3, minWidth: 120 },
    { field: "Marca", headerName: "Marca", flex: 2, minWidth: 120 },
    { field: "Modelo", headerName: "Modelo", flex: 1, minWidth: 120 },
    { field: "Serie", headerName: "Serie", flex: 3, minWidth: 120 },
    { field: "MAC", headerName: "MAC", flex: 3, minWidth: 120 },
    { field: "Tipo", headerName: "Tipo", flex: 2, minWidth: 120 },
    { field: "Último cambio", headerName: "Último cambio", flex: 1, minWidth: 120 },
    
];
export const kioscosDetalles = [
    "Fecha",
    "Zona",
    "Acceso",
    "Tipo",
    "Requiere Entrada",
    "Requiere Salida",
    "Estado",
];

export const eventos = [
    { field: "Nombre y Apellido", headerName: "Nombre y Apellido", flex: 1 },
    { field: "Documento", headerName: "Documento", flex: 1, minWidth: 100, maxWidth: 100 },
    { field: "Entrada/Salida", headerName: "Entrada/Salida", flex: 1, minWidth: 120, maxWidth: 120},
    { field: "Fecha y hora", headerName: "Fecha y hora", flex: 1, minWidth: 160, maxWidth:160 },
    { field: "Acceso", headerName: "Acceso", flex: 1.5, minWidth: 120 },
    { field: "Zona", headerName: "Zona", flex: 1, minWidth: 120 },
];

export const administracion = [
    "Apellido y Nombre",
    "DNI",
    "Género",
    "Fecha de nacimiento",
    "Servicio",
    "Rol",
    "Fecha de solicitud",
    "Fecha de alta",
    "Estado",
];
export const usuariosXServicio = [
    {
        field: "fullName",
        headerName: "Apellido y Nombre",
        flex: 1,
        minWidth: 180,
    },
    {
        field: "document",
        headerName: "Documento",
        type: "number",
        format: "number",
        width: 120,
    },
    {
        field: "documentType",
        headerName: "Tipo",
        width: 70,
    },
    {
        field: "gender",
        headerName: "Género",
        width: 70,
        align: "center",
    },
    {
        field: "birthDay",
        headerName: "Nacimiento",
        type: "date",
        format: "date",
    },
    {
        field: "email",
        headerName: "Email",
        flex: 1,
    },
    {
        field: "rol",
        headerName: "Rol",
        minWidth: 120,
    },
    {
        field: "onboard",
        headerName: "Onboard",
        align: "center",
    },
    {
        field: "creationDate",
        headerName: "Alta",
        type: "date",
        format: "date",
    },
    {
        field: "status",
        headerName: "Estado",
    },
    {
        field: "statusDate",
        headerName: "Fecha",
        type: "date",
        format: "date",
    },
];

export const dashboardAccesos = [
    "Zona",
    "Acceso",
    "Horario",
    "Descripción",
    { field: "Estado", headerName: "Estado", maxWidth: 100 },
    "Fecha",
];

export const dashboardAccesosEstados = [
    {
        field: "timestamp",
        headerName: "Fecha",
        type: "dateTime",
        format: "dateTime",
        width: 200,
    },
    {
        field: "horario",
        headerName: "Horario",
        flex: 1,
    },
    {
        field: "descripcion",
        headerName: "Descripcion",
        flex: 3,
    },
    {
        field: "status",
        headerName: "Estado",
        width: 200,
    },
];

export const document = [
    "Nombre",
    "Tipo",
    "Fecha",
    "Identificación externa",
    "Descripción",
    "Tipo Firma",
    "Firmas internas",
    "Firmas externas",
    "Fecha Estado",
    "Estado",
    "Grupo",
    "Referencia",
];

export const participants = [
    "Nombre y apellido",
    "Tipo Documento",
    "Nro Documento",
    "Rol",
    "E-mail",
    "Fecha Estado",
    "Estado",
    "Orden",
    "Tipo Firma"
];

export const inviteParticipants = [
    "Nombre y apellido",
    "Tipo Documento",
    "Nro Documento",
];
